import { useMemo } from "react";

import { allTimezones, useTimezoneSelect } from "./timezone-select";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "./ui/select";

interface TimezoneFieldClientProps {
    value?: string;
    onChange?: (timezone: string) => void;
}

export default function TimezoneFieldClient({
    value,
    onChange,
}: TimezoneFieldClientProps) {
    // AIDEV-NOTE: Add Europe/Madrid as custom timezone option since it's grouped under Europe/Brussels by default
    const customTimezones = useMemo(
        () => ({
            ...allTimezones,
            "Europe/Madrid": "Madrid",
        }),
        [],
    );

    // labelStyle "altName" → "(UTC+02:00) Europe/Madrid"
    const { options } = useTimezoneSelect({
        timezones: customTimezones,
        labelStyle: "altName",
    });

    return (
        <Select value={value} onValueChange={onChange}>
            <SelectTrigger className="w-full">
                <SelectValue placeholder="Select a timezone" />
            </SelectTrigger>

            <SelectContent className="max-h-64">
                {options.map((o) => (
                    <SelectItem key={o.value} value={o.value}>
                        {o.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
